"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RememberedAccountItem = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _classnames = _interopRequireDefault(require("classnames"));
var _formatString = require("../../utils/formatString");
var _rememberedAccounts = require("../../types/rememberedAccounts");
var _mapTypeToIcon = require("./mapTypeToIcon");
var _DeletItemSwipeButton = require("../DeletItemSwipeButton");
var _ArrowIcon = require("./ArrowIcon");
var _TrashIcon = require("./TrashIcon");
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RememberedAccountItem = _ref => {
  let {
    type,
    value,
    index,
    onClick,
    onDelete
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  const handleClick = React.useCallback(() => {
    onClick(type, value, index);
  }, [type, value, index, onClick]);
  const handleDelete = React.useCallback(e => {
    e.stopPropagation();
    onDelete(type, value, index);
  }, [type, value, index, onDelete]);
  const formattedValue = React.useMemo(() => {
    if (type === _rememberedAccounts.ERememberedAccountType.Phone) {
      return (0, _formatString.formatPhoneWithSpecialChars)(value);
    } else {
      return value;
    }
  }, [value, type]);
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: (0, _classnames.default)(styles['container'], styles[`container--${deviceType}`]),
    "data-testid": "RememberedAccountItem"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon']
  }, (0, _mapTypeToIcon.mapTypeToIcon)(type)), /*#__PURE__*/React.createElement("div", {
    className: styles['text-value']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, formattedValue)), /*#__PURE__*/React.createElement("button", {
    "data-name": "ChevronBtn",
    className: (0, _classnames.default)(styles['chevron-button'], styles[`chevron-button--${deviceType}`])
  }, /*#__PURE__*/React.createElement(_ArrowIcon.ArrowIcon, null)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement("button", {
    "data-name": "CloseBtn",
    className: (0, _classnames.default)(styles['delete-button'], styles[`delete-button--${deviceType}`]),
    onClick: handleDelete
  }, /*#__PURE__*/React.createElement(_TrashIcon.TrashIcon, null)))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true,
    tablet: true
  }, /*#__PURE__*/React.createElement(_DeletItemSwipeButton.DeletItemSwipeButton, {
    onClick: handleDelete
  })));
};
exports.RememberedAccountItem = RememberedAccountItem;